
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[p]",
      function () {
        return require("private-next-pages/[p].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[p]"])
      });
    }
  